import { formatPrice, getDiscountedPrice } from "@/lib/cart/pricing";

interface PriceDisplayProps {
  price: number;
  discountPercent?: number;
  className?: string;
  size?: "sm" | "md" | "lg" | "xl";
  align?: "left" | "center" | "right";
  showDiscountLabel?: boolean;
  prefix?: string;
}

export function ProductPrice({ 
  price, 
  discountPercent, 
  className = "", 
  size = "md", 
  align = "left",
  showDiscountLabel = true,
  prefix
}: PriceDisplayProps) {
  const hasDiscount = discountPercent !== undefined && discountPercent > 0;
  const sellingPrice = getDiscountedPrice(price, discountPercent);
  
  const sizeClasses = {
    sm: "text-sm",
    md: "text-base",
    lg: "text-lg",
    xl: "text-2xl"
  };

  const alignClasses = {
    left: "items-baseline",
    center: "items-center justify-center",
    right: "items-baseline justify-end"
  };

  if (!hasDiscount) {
    return (
      <div className={`flex items-baseline gap-1 ${className}`}>
        {prefix && (
          <span className="text-[10px] uppercase tracking-[0.1em] text-black/40 mr-1">
            {prefix}
          </span>
        )}
        <span className={`${sizeClasses[size]} text-black`} style={{ fontFamily: size === "xl" ? "'Playfair Display', serif" : "'Inter', sans-serif" }}>
          {formatPrice(price)}
        </span>
      </div>
    );
  }

  return (
    <div className={`flex flex-col gap-0.5 ${alignClasses[align]} ${className}`}>
      {showDiscountLabel && (
        <span className="text-[10px] font-medium uppercase tracking-[0.1em] text-[#C6A15B]">
          {discountPercent}% Off
        </span>
      )}
      <div className="flex items-baseline gap-2">
        {prefix && (
          <span className="text-[10px] uppercase tracking-[0.1em] text-black/40 mr-1">
            {prefix}
          </span>
        )}
        <span className={`${sizeClasses[size]} text-black`} style={{ fontFamily: size === "xl" ? "'Playfair Display', serif" : "'Inter', sans-serif" }}>
          {formatPrice(sellingPrice)}
        </span>
        <span className="text-xs text-black/40 line-through decoration-black/30">
          {formatPrice(price)}
        </span>
      </div>
    </div>
  );
}
